import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import nccBuildingImg from "images/GroupCompany/ncc-building-motoasakusa.jpeg";
import { useTranslation } from "react-i18next";
import BgTitle from "components/title/BgTitle";
import CompanyProfileMobileView from "./CompanyProfileMobileView";

const BgWrapper = styled.div`
  ${tw`relative`}
`;

const Container = tw.div`relative mx-auto px-6 py-16 max-w-screen-xl`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between items-center`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;

const ImageColumn = tw(Column)`md:w-6/12 lg:w-5/12 flex-shrink-0`;
const Image = styled.img`
  ${tw`w-full rounded-lg shadow-lg`};
  object-fit: cover;
  max-height: 450px;
`;

const TextColumn = styled(Column)((props) => [
  tw`md:w-6/12 mt-6 md:mt-0 flex flex-col items-center md:items-start`,
  props.textOnLeft ? tw`md:mr-8` : tw`md:ml-8`,
]);

const TextContent = tw.div`w-full`;
const Description = tw.p`text-gray-700 text-sm md:text-base leading-relaxed mt-4`;

const Statistics = tw.div`mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6 w-full`;
const Statistic = styled.div`
  ${tw`flex items-center bg-gray-200 justify-center md:justify-start p-4 rounded-lg bg-white shadow-md`};
  backdrop-filter: blur(10px); /* Glass Effect */
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
`;

const Icon = tw.div`text-ncc text-2xl md:text-2xl mr-4`;
const Key = tw.div`text-gray-600 text-sm md:text-base font-semibold`;
const Value = tw.div`text-gray-900 text-sm md:text-sm font-bold`;

export default ({ isXs = false, textOnLeft = false }) => {
  const { t } = useTranslation();

  if (isXs) return <CompanyProfileMobileView />;

  const statistics = [
    {
      key: t("home_section6_founding_key"),
      value: t("home_section6_founding_value"),
      icon: <i className="fa-solid fa-building"></i>,
    },
    {
      key: t("home_section6_main_office_key"),
      value: t("home_section6_main_office_value"),
      icon: <i className="fa-solid fa-house-chimney"></i>,
    },
    {
      key: t("home_section6_employee_key"),
      value: t("home_section6_employee_value"),
      icon: <i className="fa-solid fa-users"></i>,
    },
    {
      key: t("home_section6_capital_key"),
      value: t("home_section6_capital_value"),
      icon: <i className="fa-solid fa-yen-sign"></i>,
    },
  ];

  return (
    <BgWrapper>
      <Container>
        <TwoColumn>
          {/* Image Column */}
          <ImageColumn>
            <Image src={nccBuildingImg} alt="Company Building" />
          </ImageColumn>

          {/* Text Column */}
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              <BgTitle text={t("home_section6_title")} />
              <Description>{t("home_section6_desc")}</Description>
              <Statistics>
                {statistics.map((statistic, index) => (
                  <Statistic key={index}>
                    <Icon>{statistic.icon}</Icon>
                    <div>
                      <Key>{statistic.key}</Key>
                      <Value>{statistic.value}</Value>
                    </div>
                  </Statistic>
                ))}
              </Statistics>
            </TextContent>
          </TextColumn>
        </TwoColumn>
      </Container>
    </BgWrapper>
  );
};
